import React, { useEffect, useState, useRef } from "react";
import { FaArchive, FaPen, FaTrash, FaPrint } from "react-icons/fa";
import { FiChevronDown } from "react-icons/fi";
import { motion, AnimatePresence } from "framer-motion";
import DispatchPackageCard from "../DispatchPackageCard/DispatchPackageCard";
import styles from "./StorageSection.module.css";

export default function StorageSection({
  storageId,
  storageName,
  pkgs,
  selectedPackageIds,
  handlePackageClick,
  setSelectedPackage,
  actions = false,
  onEdit = () => {},
  onDelete = () => {},
  onPrint = () => {},
  toggle = true,
  storageColor
}) {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    setOpen(toggle);
  }, [toggle]);

  return (
    <div className={styles.storageSection}>
      {/* Header */}
      <div className={styles.storageHeader}>
        <h3
          className={styles.storageSectionTitle}
          onClick={() => setOpen(!open)}
          style={{ color: storageColor }}
        >
          <motion.div
            animate={{ rotate: open ? 180 : 0 }}
            transition={{ duration: 0.3 }}
            className={styles.chevronIconWrapper}
          >
            <FiChevronDown
              className={styles.chevronIcon}
              style={{ color: storageColor }}
            />
          </motion.div>
          <FaArchive style={{ marginLeft: "6px", color: storageColor }} />
          {storageName}
          <span
            className={styles.packageCountPill}
            style={{ backgroundColor: storageColor }}
          >
            {pkgs.length} items
          </span>
        </h3>

        {actions && (
          <div className={styles.actionsContainer}>
            <button
              className={styles.iconButton}
              onClick={() => onEdit(storageId)}
              title="Edit"
            >
              <FaPen style={{ color: storageColor }} />
            </button>

            <button
              className={styles.iconButton}
              onClick={() => onDelete(storageId)}
              title="Delete"
            >
              <FaTrash style={{ color: storageColor }} />
            </button>

            <button
              className={styles.iconButton}
              onClick={() => onPrint(storageId)}
              title="Print"
            >
              <FaPrint style={{ color: storageColor }} />
            </button>
          </div>
        )}
      </div>

      <div className={styles.dividerLine}></div>

      {/* Contenido animado */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            className={styles.packageGrid}
          >
            {pkgs.map((pkg) => (
              <DispatchPackageCard
                key={pkg.packageId}
                pkg={pkg}
                selected={selectedPackageIds.includes(pkg.packageId)}
                onClick={() => handlePackageClick(pkg.packageId)}
                onDetailClick={setSelectedPackage}
                moveTo={3}
                storageColor={storageColor}
              />
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
